import Box from "@mui/material/Box";
import {alpha, Grid} from "@mui/material";
import React, {FC} from "react";
import Typography from "@mui/material/Typography";
import {IHomeSteps} from "../../../../store/home/Helper";
import {useTranslation} from "react-i18next";
import {useTheme} from "@mui/material/styles";

interface IProps {
    steps: IHomeSteps[]
}

const VerticalStepper: FC<IProps> = (props) => {
    const {i18n} = useTranslation()
    const theme = useTheme()

    return (
        <Box mt={4} display="inline-flex" height={700} width="100%" gap={2}>
            <Grid item xs={1.5} container direction="column" justifyContent="space-around" alignItems="center"
                  textAlign="center"
                  sx={{position: 'relative'}}>
                <Box sx={{
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    bgcolor: theme.palette.primary.main,
                    zIndex: 0,
                    width: "3px",
                    background: `linear-gradient(to bottom, ${alpha(theme.palette.primary.main, .05)}, ${alpha(theme.palette.primary.main, .7)}, ${alpha(theme.palette.primary.main, .05)})`,
                }}/>
                {props.steps.map((s) => (
                    <Grid key={s[`label_${i18n.language}`]} container item xs={12 / props.steps.length}
                          alignItems="center"
                          justifyContent="center">
                        <Box sx={{
                            height: '25px',
                            width: '25px',
                            borderRadius: '50%',
                            bgcolor: theme.palette.primary.main,
                            boxShadow: 2
                        }}/>
                    </Grid>
                ))}
            </Grid>
            <Grid item xs={10.5} container direction="column" justifyContent="space-around">
                {props.steps.map((s) => (
                    <Grid key={s[`label_${i18n.language}`]} container item xs={12 / props.steps.length}
                          alignItems="center">
                        <Typography color="primary" variant='h6' sx={{
                            textAlign: 'center',
                        }}>
                            {s[`label_${i18n.language}`]}
                        </Typography>
                    </Grid>
                ))}
            </Grid>
        </Box>
    )
}

export default VerticalStepper
